import { render, staticRenderFns } from "./ImpresionListaAbordaje.vue?vue&type=template&id=6b4db4ca&scoped=true&"
import script from "./ImpresionListaAbordaje.vue?vue&type=script&lang=js&"
export * from "./ImpresionListaAbordaje.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b4db4ca",
  null
  
)

export default component.exports